import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaDispersionPagosPagados', NominasNominaDispersionPagosPagados)

function NominasNominaDispersionPagosPagados($http) {
  this.post = function (idProyecto, idNomina, idTipoPago, data) {
    return $http.post('/api/nominas/nomina/dispersion/pagos/pagados', data, {
      params: {id_proyecto: idProyecto, id_nomina: idNomina, id_tipo_pago: idTipoPago},
      schema: this.schema,
      clearCache: 'nominas',
    })
  }.bind(this)

  this.delete = function (idProyecto, idNomina, idTipoPago, data) {
    return $http.put('/api/nominas/nomina/dispersion/pagos/pagados', data, {
      params: {id_proyecto: idProyecto, id_nomina: idNomina, id_tipo_pago: idTipoPago},
      schema: this.schema,
      headers: {'X-HTTP-Method-Override': 'DELETE'},
      clearCache: 'nominas',
    })
  }.bind(this)

  this.schema = {
    id: 'number',
    cheque_numero: 'number',
    fecha_pago: 'date',
    indice: 'number',
    status_pagado: 'boolean',
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Dispersion/Pagos/Pagados.js